import currencyFilter from "./currency.filter";

/**
 * Фильтр суммы
 * @param value Исходное значение
 * @param useSign Признак использования знака + для положительных чисел
 * @param currencyCharCode Буквенный код валюты
 * @returns Форматированное значение
 */
export default function sumFilter(
  value: any,
  useSign: boolean = false,
  currencyCharCode: string = ""
) {
  if (value == null || value == undefined) return "";

  if (currencyCharCode == null || currencyCharCode == undefined)
    currencyCharCode = "";

  let tempSum = value.toString().replace(",", ".");
  tempSum = parseFloat(tempSum).toFixed(2);
  const sign = value < 0 ? "-" : useSign ? "+" : "";
  tempSum = value.toString().replace(".", ",");
  if (tempSum.indexOf(",") == -1) tempSum += ",00";

  let fract = tempSum
    .substr(tempSum.indexOf(",") + 1, 2)
    .replace(/[^\d]/gi, "");
  if (fract.length == 1) fract += "0";
  if (fract.length == 0) fract += "00";

  let int = tempSum.substr(0, tempSum.indexOf(",")).replace(/[^\d]/gi, "");
  if (int.length == 0) int = "0";

  // Разбавляем пробелами
  for (let i = 0; i < int.length; i++) {
    if (i % 4 == 0) {
      int = int.substr(0, int.length - i) + " " + int.substr(int.length - i);
    }
  }
  int = int.substr(0, int.length - 1);
  return `${sign ? sign + " " : ""}${int}${fract ? "," + fract : ""}${
    currencyCharCode ? " " + currencyFilter(currencyCharCode) : ""
  }`;
}
